import type { Unsubscriber } from "svelte/store"
import { writable } from "svelte/store"
import { getAuth, type User } from "firebase/auth"

export { default as LoginView } from "./view.svelte"
export { default as SignInWithCode } from "./code.svelte"
export { default as SignInAnonymously } from "./anonymously.svelte"
export { default as UserAuthContainer } from "./container.svelte"

export const loggedIn = writable<boolean>(false)

export enum LoginMethod {
  GOOGLE = "google",
  EMAIL = "email",
}

export function onLoggedIn(fn: (user: User) => void): Unsubscriber {
  let isFirst = true
  const unsub = loggedIn.subscribe((val) => {
    if (!isFirst && val) {
      fn(getAuth().currentUser)
    }
  })
  isFirst = false
  return unsub
}

export function onLoggedOut(fn: () => void): Unsubscriber {
  let isFirst = true
  const unsub = loggedIn.subscribe((val) => {
    if (!isFirst && !val) {
      fn()
    }
  })
  isFirst = false
  return unsub
}
